import React from "react"

import classNames from "classnames"

import { times } from "shared/lib/times"
import { Input } from "shared/ui/input/Input"

export interface LoadingFormProps {
  loadingFieldAmount?: number
  variant?: React.ComponentProps<typeof Input.Loader>["variant"]
  className?: string
}

export const LoadingForm = React.memo(
  ({ variant, className, loadingFieldAmount = 8 }: LoadingFormProps) => (
    <div className={classNames("rjsf-form", "loading", className)}>
      {times(loadingFieldAmount, num => (
        <div className="rjsf-form__field-container">
          <div className="rjsf-form__field grid-60">
            <Input.Loader key={`loader-${num.toString()}`} variant={variant} />{" "}
          </div>
        </div>
      ))}
    </div>
  )
)
